import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Page } from '../domain/page.model';
import { DebugCaptureRuleDto, DebugCaptureRuleListFilter, DebugCaptureRuleRequest } from '../domain/debug-capture.model';
import { HttpUtils } from '../utils/http-utils';

/** NSR-11a client: vb-core's DebugCaptureRuleController (GET/POST/PUT/DELETE /api/debug-capture-rules). */
@Injectable({ providedIn: 'root' })
export class DebugCaptureRuleService {
  private readonly baseUrl = `${environment.serviceUrl}/api/debug-capture-rules`;

  constructor(private readonly httpClient: HttpClient) {
  }

  query(filter: DebugCaptureRuleListFilter): Observable<Page<DebugCaptureRuleDto>> {
    return this.httpClient.get<Page<DebugCaptureRuleDto>>(this.baseUrl, {
      params: HttpUtils.getHttpParams(filter),
    });
  }

  getById(id: string): Observable<DebugCaptureRuleDto> {
    return this.httpClient.get<DebugCaptureRuleDto>(`${this.baseUrl}/${id}`);
  }

  create(request: DebugCaptureRuleRequest): Observable<DebugCaptureRuleDto> {
    return this.httpClient.post<DebugCaptureRuleDto>(this.baseUrl, request);
  }

  update(id: string, request: DebugCaptureRuleRequest): Observable<DebugCaptureRuleDto> {
    return this.httpClient.put<DebugCaptureRuleDto>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.baseUrl}/${id}`);
  }

  enable(id: string): Observable<DebugCaptureRuleDto> {
    return this.httpClient.post<DebugCaptureRuleDto>(`${this.baseUrl}/${id}/enable`, {});
  }

  disable(id: string): Observable<DebugCaptureRuleDto> {
    return this.httpClient.post<DebugCaptureRuleDto>(`${this.baseUrl}/${id}/disable`, {});
  }
}
